document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".faq-category-link");
  const groups = document.querySelectorAll(".faq-category-group");

  links.forEach((link) => {
    link.addEventListener("click", function () {
      const filter = this.getAttribute("data-filter");

      groups.forEach((group) => {
        group.style.display = "none";
      });

      const targetGroup = document.querySelector(
        '.faq-category-group[data-category="' + filter + '"]'
      );
      if (targetGroup) {
        targetGroup.style.display = "block";

        const firstCollapse = targetGroup.querySelector(".accordion-collapse");
        const firstButton = targetGroup.querySelector(".accordion-button");

        if (firstCollapse && firstButton) {
          targetGroup.querySelectorAll(".accordion-collapse").forEach((c) => {
            c.classList.remove("show");
          });
          targetGroup.querySelectorAll(".accordion-button").forEach((b) => {
            b.classList.add("collapsed");
            b.setAttribute("aria-expanded", "false");
          });

          firstCollapse.classList.add("show");
          firstButton.classList.remove("collapsed");
          firstButton.setAttribute("aria-expanded", "true");
        }
      }

      links.forEach((l) => l.classList.remove("active"));
      this.classList.add("active");
    });
  });
});
